<template>
  <b-modal
    id="viewImportCalendar"
    size="sm"
    ok-only
    ok-title="Chiudi"
    ok-variant="-transparent"
    header-bg-variant="lisaweb"
    no-close-on-esc
    no-close-on-backdrop
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <b-icon icon="calendar"></b-icon>
        <span>Import</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        <base-icon name="close" width="14" height="14" />
      </button>
    </template>

    <import-calendar :max="max"></import-calendar>
  </b-modal>
</template>
<script>
import ImportCalendar from "@/components/ImportCalendar";
import BaseIcon from "../BaseIcon.vue";

export default {
  components: {
    BaseIcon,
    ImportCalendar,
  },
  props: {
    max: null,
  },
};
</script>
<style lang="scss" scoped></style>
